export function PageLoader() {
  return (
    <div className="grid min-h-screen place-items-center bg-sand-50" role="status">
      <div className="flex items-center gap-3 text-sm font-semibold text-ink-700">
        <span className="size-3 animate-pulse rounded-full bg-mint-500" />
        Loading Pepsa
      </div>
    </div>
  )
}
